export default ngInject(($scope, $rootScope, settings) => {
  $scope.settings = $rootScope.settings = settings;
});
